import i18n from '../i18n'
import { formatMoney, formatPercentage } from '@/utils/NumericMutations'
import { utcToLocalDate } from '../utils/DateFormatter'
import { SETTING_KEYS } from '@/utils/UserSettings.js'
import { DataTableColumn, ColumnSet } from '@/model/DataTableColumn.js'

export function accountHeaders () {
  const columns = ([
    new DataTableColumn({
      id: 0,
      sortable: true,
      text: i18n.t('name'),
      value: 'name',
      hidable: false
    }),
    new DataTableColumn({
      id: 1,
      sortable: true,
      text: i18n.t('code'),
      value: 'code',
      hidable: true
    }),
    new DataTableColumn({
      id: 2,
      sortable: true,
      text: i18n.t('exportCode'),
      value: 'exportCode',
      hidable: true
    }),
    new DataTableColumn({
      id: 3,
      sortable: true,
      text: i18n.t('insuranceExpiryDate'),
      value: 'insuranceExpiryDate',
      align: 'center',
      hidable: true
    }),
    new DataTableColumn({
      id: 4,
      sortable: true,
      text: i18n.t('certificationExpiryDate'),
      value: 'certificationExpiryDate',
      align: 'center',
      hidable: true
    }),
    new DataTableColumn({
      id: 5,
      sortable: false,
      text: i18n.t('tags'),
      value: 'accountTags',
      align: 'center',
      hidable: false
    }),
    new DataTableColumn({
      id: 6,
      sortable: false,
      text: i18n.t('related'),
      value: 'related',
      align: 'center',
      hidable: false
    }),
    new DataTableColumn({
      id: 7,
      sortable: false,
      text: i18n.t('actions'),
      value: 'actions',
      align: 'center',
      hidable: false
    })
  ])

  return new ColumnSet({
    columns,
    setName: 'AccountGridHeaders',
    userSettingKey: SETTING_KEYS.ACCOUNT_GRID_HIDDEN_COLUMNS
  })
}

export function addressTableHeaders () {
  return [
    {
      sortable: true,
      text: i18n.t('streetAddressOne'),
      value: 'addressLine1'
    },
    {
      sortable: true,
      text: i18n.t('streetAddressTwo'),
      value: 'addressLine2'
    },
    {
      sortable: true,
      text: i18n.t('city'),
      value: 'city'
    },
    {
      sortable: true,
      text: i18n.t('zipCode'),
      value: 'postalCode'
    },
    {
      sortable: true,
      text: i18n.t('state'),
      value: 'state'
    },
    {
      sortable: false,
      text: i18n.t('actions'),
      value: 'actions',
      align: 'center'
    }
  ]
}

export function accountBulkImportPreviewHeaders () {
  return ([
    {
      sortable: true,
      text: i18n.t('name'),
      value: 'name',
      width: '150px'
    },
    {
      sortable: true,
      text: i18n.t('code'),
      value: 'code',
      width: '150px'
    },
    {
      sortable: true,
      text: i18n.t('exportCode'),
      value: 'exportCode',
      width: '150px'
    },
    {
      sortable: true,
      text: i18n.t('shippingAddress'),
      value: 'shipping',
      width: '250px'
    },
    {
      sortable: true,
      text: i18n.t('billingAddress'),
      value: 'billing',
      width: '250px'
    },
    {
      sortable: false,
      text: i18n.t('tags'),
      value: 'tags',
      width: '250px'
    },
    {
      sortable: false,
      text: i18n.t('trailerIdentifiers'),
      value: 'trailerIds',
      width: '250px'
    },
    {
      sortable: false,
      text: i18n.t('contacts'),
      value: 'contacts'
    }
  ])
}

export function accountPayableHeaders () {
  const columns = ([
    new DataTableColumn({
      id: 1,
      sortable: true,
      text: '',
      value: 'status',
      align: 'center',
      hidable: false
    }),
    new DataTableColumn({
      id: 2,
      sortable: true,
      text: i18n.t('title'),
      value: 'paymentNote',
      hidable: false
    }),
    new DataTableColumn({
      id: 3,
      sortable: true,
      text: i18n.t('activity'),
      value: 'activityName',
      hidable: false
    }),
    new DataTableColumn({
      id: 4,
      sortable: true,
      text: i18n.t('entity'),
      value: 'businessEntityName',
      hidable: true
    }),
    new DataTableColumn({
      id: 5,
      sortable: true,
      text: i18n.t('account'),
      value: 'accountName',
      align: 'left',
      hidable: true
    }),
    new DataTableColumn({
      id: 6,
      sortable: true,
      text: i18n.t('issuedAt'),
      value: 'issuedAt',
      align: 'center',
      hidable: false
    }),
    new DataTableColumn({
      id: 7,
      sortable: true,
      text: i18n.t('payDate'),
      value: 'payDate',
      align: 'center',
      hidable: false
    }),
    new DataTableColumn({
      id: 8,
      sortable: true,
      text: i18n.t('glCode'),
      value: 'glCode',
      align: 'center',
      hidable: true
    }),
    new DataTableColumn({
      id: 9,
      sortable: true,
      text: i18n.t('glOffset'),
      value: 'glOffset',
      align: 'center',
      hidable: true
    }),
    new DataTableColumn({
      id: 10,
      sortable: true,
      text: i18n.t('createdBy'),
      value: 'createdByUser',
      align: 'center',
      hidable: true
    }),
    new DataTableColumn({
      id: 11,
      sortable: true,
      text: i18n.t('createdAt'),
      value: 'createdAt',
      align: 'center',
      hidable: true
    }),
    new DataTableColumn({
      id: 12,
      sortable: true,
      text: i18n.t('amount'),
      value: 'amount',
      align: 'right',
      hidable: false
    }),
    new DataTableColumn({
      id: 13,
      sortable: false,
      text: i18n.t('actions'),
      value: 'actions',
      align: 'center',
      hidable: false
    })
  ])

  return new ColumnSet({
    columns,
    setName: 'AccountDetailPaymentsHeaders',
    userSettingKey: SETTING_KEYS.ACCOUNT_DETAIL_PAYMENTS_HEADERS
  })
}

export function accountPayableTemplateHeaders () {
  const columns = ([
    new DataTableColumn({
      id: 1,
      hidable: false,
      sortable: true,
      text: '',
      value: 'status',
      align: 'center'
    }),
    new DataTableColumn({
      id: 2,
      hidable: false,
      sortable: true,
      text: i18n.t('title'),
      value: 'paymentNote'
    }),
    new DataTableColumn({
      id: 3,
      hidable: false,
      sortable: true,
      text: i18n.t('activity'),
      value: 'activityName'
    }),
    new DataTableColumn({
      id: 4,
      hidable: true,
      sortable: true,
      text: i18n.t('entity'),
      value: 'businessEntityName'
    }),
    new DataTableColumn({
      id: 5,
      hidable: true,
      sortable: true,
      text: i18n.t('account'),
      value: 'accountName',
      align: 'left'
    }),
    new DataTableColumn({
      id: 6,
      hidable: false,
      sortable: true,
      text: i18n.t('startDate'),
      value: 'startDate',
      align: 'center',
      format: utcToLocalDate
    }),
    new DataTableColumn({
      id: 7,
      hidable: true,
      sortable: true,
      text: i18n.t('glCode'),
      value: 'glCode',
      align: 'center'
    }),
    new DataTableColumn({
      id: 8,
      hidable: true,
      sortable: true,
      text: i18n.t('glOffset'),
      value: 'glOffset',
      align: 'center'
    }),
    new DataTableColumn({
      id: 9,
      hidable: true,
      sortable: true,
      text: i18n.t('createdBy'),
      value: 'createdByUser',
      align: 'center'
    }),
    new DataTableColumn({
      id: 10,
      hidable: true,
      sortable: true,
      text: i18n.t('createdAt'),
      value: 'createdAt',
      align: 'center',
      format: c => utcToLocalDate(c, 'MM/DD/YYYY')
    }),
    new DataTableColumn({
      id: 11,
      hidable: false,
      sortable: true,
      text: i18n.t('lastTriggered'),
      value: 'lastInstantiated',
      align: 'center',
      format: c => utcToLocalDate(c, 'MM/DD/YYYY')
    }),
    new DataTableColumn({
      id: 12,
      hidable: false,
      sortable: true,
      text: i18n.t('amount'),
      value: 'amount',
      align: 'right',
      format: formatMoney
    }),
    new DataTableColumn({
      id: 13,
      hidable: false,
      sortable: false,
      text: i18n.t('actions'),
      value: 'actions',
      align: 'center'
    })
  ])

  return new ColumnSet({
    columns,
    setName: 'AccountDetailPaymentTemplateHeaders',
    userSettingKey: SETTING_KEYS.ACCOUNT_DETAIL_PAYMENT_TEMPLATE_HEADERS
  })
}

export function accountPaymentRegisterHeaders () {
  return [
    {
      sortable: true,
      text: i18n.t('title'),
      value: 'note',
      align: 'left'
    },
    {
      sortable: true,
      text: i18n.t('activity'),
      value: 'activity',
      align: 'center'
    },
    {
      sortable: true,
      text: i18n.t('glCode'),
      value: 'glCode',
      align: 'center'
    },
    {
      sortable: true,
      text: i18n.t('glOffset'),
      value: 'glOffset'
    },
    {
      sortable: true,
      text: i18n.t('amount'),
      value: 'amount',
      align: 'right'
    }
  ]
}

export function overweightThresholdHeaders (isCRUD = false) {
  const result = [{
    value: 'threshold',
    text: i18n.t('thresholdLb'),
    align: 'right'
  },
  {
    value: 'penaltyAmount',
    text: i18n.t('penalty'),
    align: 'right'
  }]

  if (isCRUD) {
    result.push(
      {
        value: 'actionLeft',
        text: '',
        align: 'left'
      },
      {
        value: 'actionRight',
        text: '',
        align: 'center'
      }
    )
  }

  return result
}

export function ticketBookHeaders () {
  return [{
    value: 'status',
    text: i18n.t('status'),
    align: 'center',
    sortable: true
  },
  {
    value: 'name',
    text: i18n.t('name'),
    align: 'left',
    sortable: true
  },
  {
    value: 'tract',
    text: i18n.t('assignedTo'),
    align: 'left',
    sortable: true
  },
  {
    value: 'mappedPages',
    text: i18n.t('pages'),
    align: 'right',
    sortable: true,
    sort: (a, b) => a.firstPage - b.firstPage
  },
  {
    value: 'availablePageCount',
    text: i18n.t('pagesAvailable'),
    align: 'right'
  },
  {
    value: 'totalPageCount',
    text: i18n.t('totalPages'),
    align: 'right'
  },
  {
    value: 'percentage',
    text: i18n.t('used'),
    align: 'right',
    format: formatPercentage
  },
  {
    value: 'actions',
    text: i18n.t('actions'),
    align: 'center',
    sortable: false
  }]
}

export function ticketBookCustomCells () {
  return [{
    slotName: 'status',
    value: 'status'
  },
  {
    slotName: 'name',
    value: 'name'
  },
  {
    slotName: 'tract',
    value: 'tract'
  },
  {
    slotName: 'pages',
    value: 'mappedPages'
  },
  {
    slotName: 'actions',
    value: 'actions'
  }]
}

export function ticketBookPageHeaders (crud = false) {
  return [{
    value: 'pageNumber',
    text: i18n.t('pageNumber'),
    align: 'left',
    cellClass: 'text-left',
    hidden: false,
    sortable: false
  },
  {
    value: 'ticketNumber',
    text: i18n.t('ticketNumber'),
    align: 'right',
    hidden: false,
    sortable: false
  },
  {
    value: 'actions',
    text: i18n.t('actions'),
    align: 'center',
    hidden: !crud,
    sortable: false
  }].filter(c => c.hidden === false)
}

export function lengthGroupHeaders (isCRUD = false) {
  return [{
    text: i18n.t('name'),
    value: 'label',
    sortable: true
  },
  {
    text: i18n.t('lengths'),
    value: 'logLengths',
    sortable: false
  },
  isCRUD ? {
    text: '',
    value: 'actions',
    align: 'right',
    sortable: false,
    width: 72
  } : undefined].filter(i => i)
}

export function diameterGroupHeaders (isCRUD = false) {
  return [{
    text: i18n.t('name'),
    value: 'label',
    sortable: true
  },
  {
    text: i18n.t('lower'),
    value: 'lowerBound',
    align: 'right',
    sortable: true
  },
  {
    text: i18n.t('upper'),
    value: 'upperBound',
    align: 'right',
    sortable: true
  },
  isCRUD ? {
    text: '',
    value: 'actions',
    align: 'right',
    sortable: false,
    width: 72
  } : undefined].filter(i => i)
}

export function speciesGroupHeaders (isCRUD = false) {
  return [{
    text: i18n.t('name'),
    value: 'label',
    sortable: true
  },
  {
    text: i18n.t('species'),
    value: 'species',
    align: 'center',
    sortable: false
  },
  {
    text: i18n.t('lengthGroups'),
    value: 'lengthGroups',
    align: 'center',
    sortable: false
  },
  {
    text: i18n.t('diameterGroups'),
    value: 'diameterGroups',
    align: 'center',
    sortable: false
  },
  isCRUD ? {
    text: '',
    value: 'actions',
    align: 'right',
    sortable: false,
    width: 96
  } : undefined].filter(i => i)
}

export function rateSheetDefinitionHeaders (isCRUD = false) {
  return [{
    text: i18n.t('name'),
    value: 'name',
    sortable: true
  },
  {
    text: i18n.t('product'),
    value: 'productName',
    sortable: true
  },
  {
    text: i18n.t('effectiveDate'),
    value: 'effectiveDate',
    sortable: true
  },
  isCRUD ? {
    text: '',
    value: 'actions',
    align: 'right',
    sortable: false,
    width: 72
  } : undefined].filter(i => i)
}

export function rateSheetDefinitionLineHeaders (isCRUD = false) {
  return [
    {
      text: i18n.t('speciesGroup'),
      value: 'speciesGroup',
      sortable: true
    },
    {
      text: i18n.t('lengthGroup'),
      value: 'lengthGroup',
      sortable: true
    },
    {
      text: i18n.t('diameterGroup'),
      value: 'diameterGroup',
      sortable: true
    },
    {
      text: i18n.t('grade'),
      value: 'grade',
      sortable: true
    },
    {
      text: i18n.t('endUseSort'),
      value: 'endUseSort',
      sortable: true
    },
    {
      text: i18n.t('rate'),
      value: 'rate',
      align: 'right',
      sortable: true
    },
    isCRUD ? {
      text: '',
      value: 'actions',
      align: 'right',
      sortable: false,
      width: 72
    } : undefined].filter(i => i)
}
